<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__stepper" :class="inputClass" @mousedown="()=>{}" @focus="()=>{}">
        <!-- [ICON] Minus icon :: decrease number -->
        <ur-icon-button class="ur-data-grid__edit__stepper__button ur-data-grid__edit__stepper__button--minus"
                v-if="isAddSub" :disabled="!decreasable"
                @click="decreaseNum">remove</ur-icon-button>
        <!-- [INPUT] Number input element -->
        <input class="ur-data-grid__edit__element__input
                      ur-data-grid__edit__stepper__input"
               ref="input"
               type="number" autocomplete="off" 
               :min="$_min" :max="$_max" :step="step"
               :placeholder="placeholder" :disabled="!inputEnable"
               :value="currVal" @input="(e)=>{setValue(e.target.value)}"
               @keyup.enter="keyEnter"
               v-on="{...$listeners, input:()=>{}}"/>
        <!-- [ICON] PLUS icon :: increase number -->
        <ur-icon-button class="ur-data-grid__edit__stepper__button ur-data-grid__edit__stepper__button--plus"
            v-if="isAddSub" :disabled="!increasable"
            @click="increaseNum">add</ur-icon-button>
        <!-- [ICON] UP-DOWN :: for "updown" type -->
        <div class="ur-counter__updown-wrapper" v-if="isUpDown">
            <div class="ur-counter__updown-upper" :disabled="!increasable" @click="increaseNum"/>
            <hr  class="ur-counter__updown-divider">
            <div class="ur-counter__updown-lower" :disabled="!decreasable" @click="decreaseNum"/>
        </div>
    </div>
</template>

<script>
const isNaN = Number.isNaN || window.isNaN;
function isNumber(n){
    if(n===0) return true;
    if(!n) return false;
    return !isNaN(n);
}

export default {
    name: 'urDataGridEditStepper',
    props: {
        value    : {type: [Number, String, Object],default: null},
        
        type   : {type: String}, /* default:'updown' -> $_type*/
        addsub : {type: Boolean,default: false}, // Subordinate attribute of type
        updown : {type: Boolean,default: false}, // Subordinate attribute of type
        // TODO type으로 바꾸기, updown/addsub
        controlType     : {type: String, default: undefined},
        // Validate/Action condition
        min      : {type: [String,Number],default: -Infinity}, 
        max      : {type: [String,Number],default:  Infinity}, 
        step     : {type: Number, default: 1},
        // flags
        disabled : {type: Boolean,default: false},
        placeholder: {type: String,default: undefined},
    },
    data() {return {
        currVal: null, // Null or Number
    }},
    watch: {
        value: {immediate: true, handler(val, old) {
            if(this.currVal !== val) {
                this.setValue(val); // when input comes
            }
        }},
    },
    computed: {
        // [COMPUTED] Normalize props
        $_min() {
            if(this.min===null || this.min===undefined) {return -Infinity}
            return this.min===-Infinity ? this.min : parseFloat(this.min);
        },
        $_max() {
            if(this.max===null || this.max===undefined) {return Infinity}
            return this.max=== Infinity ? this.max : parseFloat(this.max)
        },
        $_type() {
            // 1. check this.type
            switch(this.type) {
            case 'addsub': return 'addsub';
            case 'updown': return 'updown';
            }
            // 2. check type flags.
            if(this.updown) return 'updown';
            if(this.addsub) return 'addsub';
            // 3. default value
            return 'updown';
        },
        // [COMPUTED] Flags
        isUpDown() {return this.$_type==='updown'},
        isAddSub() {return this.$_type==='addsub'},
        decreasable() { return !this.disabled && (!isNumber(this.currVal) || this.$_min < this.currVal)},
        increasable() { return !this.disabled && (!isNumber(this.currVal) || this.currVal < this.$_max)},
        inputEnable() { return !this.disabled && (this.decreasable || this.increasable )},
        // [COMPUTED] Style & Classes
        inputClass()  { return {"ur-counter--disabled":this.disabled}},
    },
    methods: {
        blur(e)  {
            var v = e.target.value;
            this.setValue(v)
        },
        increaseNum() {
            // 1. check increasable
            if( !this.increasable ) {return}
            // 2. set value
            if( !isNumber(this.currVal)) { this.setValue(0) }
            else {this.setValue(this.currVal+this.step)}
            this.$emit('num:clicked',this.currVal);
        },
        decreaseNum() {
            // 1. check increasable
            if( !this.decreasable ) {return}
            // 2. set value
            if( !isNumber(this.currVal)) { this.setValue(0) }
            else {this.setValue(this.currVal-this.step)}
            this.$emit('num:clicked',this.currVal);
        },
        keyEnter(e) {
            this.setValue(e.target.value)
        },
        setValue(val) {
            var v = parseFloat(val), // v : "NaN" or "number"
                min = this.$_min,
                max = this.$_max;
            // 1. preProcess
            // 1.1 check min value
            if(v < min) {v = min}
            // 1.2 (else) check max value
            else if(max < v) {v = max}
            // 2. set value 
            //        B/C NaN !== NaN, null === null
            this.setCurrVal(v);
            // x. Do I need update?
            if( val !== v ) {this.$forceUpdate()}
        },
        setCurrVal(v) {
            var _v = parseFloat(v);
            this.currVal = isNaN(_v)?null:_v;
            this.$emit('input',this.currVal);
        },
        focus(opts) {
            this.$refs.input.focus(opts);
        },
        selectAll() {
            this.$refs.input.select();
        }
    }
};

</script>
